import React from "react";
import { useState, useEffect, useRef } from "react";
import styles from "./Register.module.css";
import close from "../../../images/close.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useRazorpay from "react-razorpay";
// import Razorpay from "razorpay";

import { useSelector } from "react-redux";
import {
  createDonation,
  createEventPaymentRequest,
  createPassPaymentRequest,
  registerForEvent,
} from "../../../api";
import SearchableDropdown from "../../components/searchDrop";
function Donate({ setReg }) {
  const toastStyle = {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
  };
  const allEvents = useSelector((state) => state.auth.upcoming);
  const [submit, setSubmit] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setphone] = useState(null);
  const [amount, setAmount] = useState();
  const [sponEvent, setSponEvent] = useState("Sphinx 2023");
  const ConRef = useRef(null);
  let token = "";
  const toastId = useRef(null);
  const disabledCol = "#6e9efa";
  const btnCol = "#95FF42";

  const PaymentLink = () => {
    //console.log("Called link");
    // ConRef.current.setAttribute("disabled", true);
    // ConRef.current.style.background = disabledCol;
    //console.log("called url");
    let body = {
      receipt: `This is the Receipt of Sponsor by ${name} for Event ${sponEvent}`,
      notes: {
        description: `Prize Money Sponsor of ${amount} for ${sponEvent}`,
      },
      name,
      email,
      phoneNumber,
      amount,
    };
    createDonation(body)
      .then((res) => {
        //console.log(res);
        ////console.log(window.env);
        if (res.status) {
          toast.info("Free Created");
        } else {
          //////console.log(process.env.REACT_APP_RAZORPAY_ID);
          toast.info("Payment Link created");
          //console.log(res);
          window.open(res.payment.paymentLink, "_blank");
          //console.log(res);
        }
      })
      .catch((err) => {
        //console.log("errror ");
        //console.log("catch error", err);
        toast.update(toastId.current, {
          render: err,
          type: "error",
          isLoading: false,
          ...toastStyle,
        });
      });
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    //////console.log(members);
    if (name == "") {
      toast.error("Name is Mandatory", toastStyle);
      return;
    }
    if (email == "" || !email.includes("@")) {
      toast.error("email is invalid", toastStyle);
      return;
    }

    if (phoneNumber.toString().length != 10) {
      toast.error(`Phone number is not valid`, toastStyle);
      return;
    }
    if (amount> 90001) {
      toast.error(`Amount should be less than 90K else please pay through NEFT`, toastStyle);
      return;
    }

    PaymentLink();
  };
  const InputField = (props) => {
    return (
      <div className={styles.inputCon}>
        <label className={styles.inputLabel}>{props.name}</label>
        <input
          className={styles.inputField}
          value={props.value}
          type={props.type}
          onChange={(e) => {
            props.setChange(e.target.value);
          }}
        ></input>
      </div>
    );
  };
  useEffect(() => {
    //console.log("weee");
  }, []);
  // const event = { title: "ROBOWARS", subTitle: "FLAGSHIP EVENTS" };
  const [teamName, setTeamName] = useState("");
  return (
    <div className={styles.con}>
      <button
        className={styles.close}
        onClick={() => {
          setReg(false);
        }}
      >
        <img src={close}></img>
      </button>
      <div className={styles.form}>
        <div className={styles.subTitle}>Sphinx 2023</div>
        <div className={styles.title}>Sponsor Us</div>
        <br></br>
        <label className={styles.subTitle}>{"Event You Want to Sponsor"}</label>

        <SearchableDropdown
          options={allEvents}
          label={"name"}
          id="_id"
          selectedVal={sponEvent}
          handleChange={(val) => setSponEvent(val)}
        ></SearchableDropdown>
        <section className={styles.formCon}>
          <div className={styles.filedsCon}>
            <div className={styles.inputCon}>
              <label className={styles.inputLabel}>{"Name"}</label>
              <input
                className={styles.inputField}
                value={name}
                type="text"
                onChange={(e) => {
                  setName(e.target.value);
                }}
              ></input>
            </div>
            <div className={styles.inputCon}>
              <label className={styles.inputLabel}>Email</label>
              <input
                className={styles.inputField}
                value={email}
                type="email"
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              ></input>
            </div>{" "}
          </div>

          <div className={styles.filedsCon}>
            <div className={styles.inputCon}>
              <label className={styles.inputLabel}>{"Phone Number"}</label>
              <input
                className={styles.inputField}
                value={phoneNumber}
                type="numeric"
                onChange={(e) => {
                  setphone(e.target.value);
                }}
              ></input>
            </div>
            <div className={styles.inputCon}>
              <label className={styles.inputLabel}>Amount (INR)</label>
              <input
                className={styles.inputField}
                value={amount}
                type="numeric"
                onChange={(e) => {
                  setAmount(e.target.value);
                }}
              ></input>
            </div>{" "}
          </div>
        </section>
        <button
          className="eventD-reg"
          style={{ margin: "auto" }}
          ref={ConRef}
          onClick={handleSubmit}
        >
          Sponsor
        </button>
      </div>
    </div>
  );
}

export default Donate;
